import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus, FiCheck, FiChevronDown } = FiIcons;

export default function ProductCard({ product, onAdd }) {
  const [isSubscribing, setIsSubscribing] = useState(true);
  const [selectedScent, setSelectedScent] = useState(product.scents?.[0] || 'Standard');
  const [isLoading, setIsLoading] = useState(false);
  const [added, setAdded] = useState(false);

  const handleAdd = () => {
    setIsLoading(true);
    setTimeout(() => {
      onAdd({ ...product, scent: selectedScent });
      setIsLoading(false);
      setAdded(true);
      setTimeout(() => setAdded(false), 2000);
    }, 600);
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
      className="bg-white group flex flex-col h-full border border-gray-100 hover:border-gray-200 transition-colors relative"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[var(--kraft-light)]">
        {product.badge && (
          <div className="absolute top-4 left-4 z-10 bg-[var(--navy)] text-[var(--mint)] text-[10px] font-bold px-3 py-1 uppercase tracking-widest">
            {product.badge}
          </div>
        )}
        <img 
          src={product.image} alt={product.name} 
          className={`w-full h-full object-cover transform group-hover:scale-105 transition-all duration-1000 ${isLoading ? 'blur-sm' : ''}`} 
        />
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/40">
            <div className="w-8 h-8 border-2 border-[var(--navy)] border-t-transparent rounded-full animate-spin" />
          </div>
        )}
      </div>

      <div className="p-6 md:p-8 flex flex-col flex-grow">
        <div className="mb-4">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[var(--mint-dark)] font-bold mb-1">{product.category}</p>
          <h3 className="text-xl font-bold text-[var(--navy)] leading-tight">{product.name}</h3>
          <p className="text-[10px] text-[var(--mint-dark)] font-bold uppercase tracking-widest mt-1 flex items-center gap-1">
            <SafeIcon icon={FiCheck} /> {product.impact}
          </p>
        </div>
        
        <p className="text-sm text-gray-500 mb-6 flex-grow leading-relaxed">{product.description}</p>

        <div className="space-y-4">
          <div className="relative">
            <select 
              value={selectedScent}
              onChange={(e) => setSelectedScent(e.target.value)}
              className="w-full p-3 bg-[var(--off-white)] border border-gray-100 rounded-sm text-xs font-bold text-[var(--navy)] appearance-none outline-none focus:border-[var(--mint-dark)]"
            >
              {product.scents?.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
            <SafeIcon icon={FiChevronDown} className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400" />
          </div>

          <div className="flex items-center justify-between">
            <span className="text-2xl font-bold text-[var(--navy)]">${product.price.toFixed(2)}</span>
            <div className="flex bg-[var(--kraft-light)] p-1 rounded-sm gap-1">
              <button onClick={() => setIsSubscribing(true)} className={`text-[9px] font-bold px-3 py-1.5 rounded-sm transition-all ${isSubscribing ? 'bg-white shadow-sm text-[var(--navy)]' : 'text-gray-400'}`}>REFILLS</button>
              <button onClick={() => setIsSubscribing(false)} className={`text-[9px] font-bold px-3 py-1.5 rounded-sm transition-all ${!isSubscribing ? 'bg-white shadow-sm text-[var(--navy)]' : 'text-gray-400'}`}>ONCE</button>
            </div>
          </div>

          <button 
            onClick={handleAdd} disabled={added || isLoading}
            className={`w-full py-4 font-bold rounded-sm flex justify-center items-center gap-3 transition-all duration-300 ${
              added ? 'bg-[var(--mint)] text-[var(--navy)]' : 'bg-[var(--navy)] text-[var(--mint)] hover:bg-[var(--navy-light)] shadow-lg'
            }`}
          >
            {added ? <><SafeIcon icon={FiCheck} /> Added</> : <><SafeIcon icon={FiPlus} /> {isSubscribing ? 'Subscribe' : 'Purchase'}</>}
          </button>
        </div>
      </div>
    </motion.div>
  );
}